@let data = section();

<section
    class="cms-hiw tg-container tg-section"
    [class.cms-hiw--has-bg]="backgroundImage()"
    [style.background-image]="
        backgroundImage() ? 'url(' + (backgroundImage()!.url | addStrapiDomainName) + ')' : null
    "
>
    @if (data.titleContent) {
        <div class="cms-hiw__title cms-content" [innerHTML]="data.titleContent | trustHtml"></div>
    }

    @if (data.items.length) {
        <ol class="cms-hiw__steps">
            @for (item of data.items; track item.id) {
                <li class="cms-hiw__step">
                    @if (item.image?.url) {
                        <cms-image class="cms-hiw__image" [media]="item.image" />
                    }
                    <div class="cms-content" [innerHTML]="item.content | trustHtml"></div>
                </li>
            }
        </ol>
    }

    @if (data.footerContent) {
        <div class="cms-hiw__footer cms-content" [innerHTML]="data.footerContent | trustHtml"></div>
    }
</section>
